<template>
    <div>
        <CCol sm="12" xs="6" class="text-right">
            <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                <span style="margin-top:20px">Tracking</span>
            </h5>
    
        </CCol>
        <div style="clear:both"></div>
        <CCol sm="12">
            <CCard style="border:none" class="b-20 mt-3">
                <CRow>
                    <div style="width:30%">
                        <div class="ml-4 mt-2">
                            <img style="width:60px" src="../assets/img/usercard1.png" />
                        </div>
                    </div>
                    <div style="width:70%">
                        <CRow class="p-2 mt-2">
                            <CCol sm="12">
                                <h3 class="custom-14px-700">
                                    Andrew Preston
                                </h3>
                            </CCol>
                            <div class="ml-2">
                                <img src="../assets/img/rate.png" style="width:20px;height:20px" />
                                <img src="../assets/img/rate.png" style="width:20px;height:20px" />
                                <img src="../assets/img/rate.png" style="width:20px;height:20px" />
                                <img src="../assets/img/rate.png" style="width:20px;height:20px" />
                                <img src="../assets/img/rate.png" style="width:20px;height:20px" />
                                <label class="custom-12px mt-2">122 review</label>
                            </div>
    
    
    
                        </CRow>
                    </div>
                </CRow>
                <CCol sm="12">
                    <CRow>
                        <div style="width:50%">
                            <h4 class="custom-14px-600 text-center" style="border-bottom: 1px solid var(--Main-Colors-Primary, #323C66);">Description</h4>
                        </div>
                        <div style="width:50%">
                            <h4 class="custom-muted-text text-center">Review</h4>
                        </div>
                        <div class="p-2">
                            <h5 class="custom-14px-600">Description</h5>
                            <p class="custom-12px">The community's need for applications that can facilitate daily activities is increasing as technology </p>
                            <h5 class="custom-14px-600">Details</h5>
                            <CRow class="m-2">
                                <div style="width:50%">
                                    <h4 class="custom-12px-500">Nationalities</h4>
                                </div>
                                <div style="width:50%">
                                    <h4 class="custom-14px-600 text-right">Indonesian</h4>
                                </div>

                                <div style="width:50%">
                                    <h4 class="custom-12px-500">Working</h4>
                                </div>
                                <div style="width:50%">
                                    <h4 class="custom-14px-600 text-right">Cleaning’s Company</h4>
                                </div>

                                <div style="width:50%">
                                    <h4 class="custom-12px-500">Years of Experience</h4>
                                </div>
                                <div style="width:50%">
                                    <h4 class="custom-14px-600 text-right">2</h4>
                                </div>

                                <div style="width:50%">
                                    <h4 class="custom-12px-500">Joined Since</h4>
                                </div>
                                <div style="width:50%">
                                    <h4 class="custom-14px-600 text-right">28-30 August 2023</h4>
                                </div>
                                <div style="width:100%">
                                <h3 class="custom-14px-500 text-center">
                                    Contact Available
                                </h3>
                                <CCol sm="12">
                                    <div class="text-center m-0">
                                    <img style="max-width:60px" src="../assets/img/colorwhatsap.png" class="mr-2"/>
                                    <img style="max-width:60px" src="../assets/img/telegram.png" class="mr-2"/>
                                    <img style="max-width:60px" src="../assets/img/coloremail.png" />
                                </div>
                                <br /><br />
                                <CButton type="button" class="button-border-blue text-white" block @click="OpenPopup()">
                            Tracking
                        </CButton>

                            </CCol>
                            </div>
                            </CRow>
                        </div>
                    </CRow>
                </CCol>
            </CCard>
        </CCol>

      
    </div>
</template>


<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";

import backgroundUrl from "../assets/img/bgHomeUser.png";
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination,
} from "hooper";

import "hooper/dist/hooper.css";
export default ({
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        HooperPagination,
        MainlayoutBottom,
    },
    data() {
        return {
            isLanguagePopupVisible: false,
            isLanguagePopupVisible1: false,
            code: ["", "", "", ""],
            hooperSettings1: {
                hideArrows: true,
            },
            backgroundUrl

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
        GoToBooking()
        {
            this.$router.push("ProfileUser");
        },
        OpenPopup()
        {
            this.$router.push("TrackingDetail");
        },
        closePopup() {
            this.isLanguagePopupVisible = false;
        },
        GoToAnother()
        {
            this.isLanguagePopupVisible1= true;
            //this.isLanguagePopupVisible = false;
          
        },
        closePopup1() {
            this.isLanguagePopupVisible1= false;
        },



    }
})
</script>

<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>